var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-block"},[_c('hr'),_c('el-button',{staticClass:"small",attrs:{"disabled":_vm.aiTemplateLoader,"type":"plain"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" "+_vm._s(_vm.$t('back'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }